import { Checkbox, Text, blue, neutral } from "@flat-ui";
import { Box } from "@mui/material";
import {
  feedbackControlWrapperSx,
  feedbackOptionRowSx,
} from "@components/analytics/in-house/feedback/analytics-feedback-helper";
import { AnalyticsFeedbackStepLayout } from "@components/analytics/in-house/feedback/analytics-feedback-step";
import { runtimeConfig } from "@src/runtime-config";
import {
  FeedbackStepDefinition,
  FeedbackStepProps,
} from "@components/analytics/in-house/feedback/analytics-feedback-types";

/** Optional consent-to-contact step. */
function AnalyticsFeedbackStep4Content({
  answers,
  onAnswersChange,
}: FeedbackStepProps): JSX.Element {
  return (
    <AnalyticsFeedbackStepLayout
      title="Open to a 20-min call to go deeper?"
      subtext="We'd love to learn from you directly. Totally optional."
    >
      <Box
        role="checkbox"
        aria-checked={answers.hasOptedInToContact}
        onClick={() =>
          onAnswersChange({ hasOptedInToContact: !answers.hasOptedInToContact })
        }
        sx={{
          ...feedbackOptionRowSx,
          borderColor: answers.hasOptedInToContact ? blue[200] : neutral[200],
          backgroundColor: answers.hasOptedInToContact
            ? blue[50]
            : "transparent",
        }}
      >
        <Box sx={feedbackControlWrapperSx}>
          <Checkbox
            checked={answers.hasOptedInToContact}
            readOnly
            controlSx={{ m: 0 }}
          />
        </Box>
        <Text variant="bodyM">I agree to be contacted about my feedback</Text>
      </Box>
      <Text variant="bodyS" color={neutral[600]}>
        If you need help with a specific problem, please contact{" "}
        <Box component="span" sx={{ color: blue[500], fontWeight: 600 }}>
          <var>{runtimeConfig.mailSupportAddress}</var>
        </Box>
      </Text>
    </AnalyticsFeedbackStepLayout>
  );
}

/** Step definition registered in the survey flow. */
export const analyticsFeedbackStep4: FeedbackStepDefinition = {
  stepName: "contact",
  StepComponent: AnalyticsFeedbackStep4Content,
  isValid: () => true,
};
